import React from "react";

type Props = {};

const CustomHeader = (props: Props) => {
  return <div>CustomHeader</div>;
};

export default CustomHeader;
